import axios from "../libs/api.request.js";

export const getFabric = params => {
    return axios.request({
      url: "pc/fabric/dmFabric",
      method: "get",
      params
    });
  };

  export const getFabricStock = params => {
      return axios.request({
          url:'pc/fabric/getFabricStock',
          method:'get',
          params
      })
  }

  export const getArchivesData = params => {
    return axios.request({
        url:'pc/dict/dmEmb',
        method:'get',
        params
    })
  }

export const getStyleData = params => {
  return axios.request({
    url:'pc/curablestyle',
    method:'get',
    params
  })
}
export const getStyleInfoData =(cloth,ecode) => {
  return axios.request({
    url:'pc/curablestyle/'+cloth+"/"+ecode,
    method:'get'
  })
}

  // 获取品类信息
  export const getCategoryInfo = params => {
      return axios.request({
          url:'pc/dict/dmCategory',
          method:'get',
          params
      })
  }

  // 获取工艺价格

  export const getCraftPrice = data => {
    return axios.request({
        url:'pc/dict/getCraftPrice',
        method:'post',
        data
    })
  }

  // 获取用户绑定工艺
  export const getUserCategory = params => {
    return axios.request({
        url:'pc/dict/processBinding',
        method:'get',
        params
    })
  }



// WEBPACK FOOTER //
// ./src/api/peofessional.js